import { render, staticRenderFns } from "./TalkRoomList.vue?vue&type=template&id=9ffc506e&scoped=true"
import script from "./TalkRoomList.vue?vue&type=script&lang=js"
export * from "./TalkRoomList.vue?vue&type=script&lang=js"
import style0 from "./TalkRoomList.vue?vue&type=style&index=0&id=9ffc506e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffc506e",
  null
  
)

export default component.exports